import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

export const ErrorToast = ({ message, onReportClick }) => {
  return (
    <div className="toast">
      <p className="toast__message">{message}</p>
      <button className="toast__button" onClick={onReportClick}>
        {i18n.t("toast.reportThisIssue")}
      </button>
    </div>
  );
};

ErrorToast.propTypes = {
  message: PropTypes.string.isRequired,
  onReportClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Common/ErrorToast.js